import React, { useState, useEffect, FC } from "react";
import { Table, Button, Tooltip, message } from "antd";
import { YHModal } from "@/components/YHModal";
import { useMaintenanceDetailsModel, IMaterialDetailModel } from "./maintenanceDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatIntPoint } from "@/utils/utils";
import { IStockStatisticDetail } from "@/views/stock/statistic/stockStatisticService";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddMaterialModal: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { materialModel: visible, workDataSource, addDataSource, transformsToDetailList, resetMaterialData, workloadData, setAddDataSource, setSearchWorkData, setWorkDataSource, setMaterialModel } = useMaintenanceDetailsModel();

    useEffect(() => {
        if (visible) {
            workloadData();
        }
    }, [visible])
    const column = (optype: number) => [
        {
            // title: '序号',
            title: Locale['SN'],
            width: 60,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编号',
            title: Locale['Material Code'],
            width: 100,
            dataIndex: 'materialCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale['Material Name'],
            width: 100,
            dataIndex: 'materialName',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 100,
            dataIndex: 'materialNameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '原单数量',
            title: Locale['Original order quantity'],
            width: 120,
            dataIndex: 'originalNum',
        }, {
            // title: '数量',
            title: Locale['Qty'],
            width: 120,
            dataIndex: 'num',
            editable: true,
        }, {
            // title: '单价',
            title: Locale['Unit Price'],
            width: 120,
            dataIndex: 'price',
        }, {
            // title: '金额',
            title: Locale['Amount'],
            width: 120,
            dataIndex: 'amount',
        }, {
            // title: '库存',
            title: Locale['Inventory'],
            width: 120,
            dataIndex: 'inventoryNum',
        }, {
            // title: '单位',
            title: Locale['Unit'],
            width: 120,
            dataIndex: 'unitName',
        }, {
            // title: '仓库',
            title: Locale['Warehouse'],
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale['Shelf'],
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            // title: '操作',
            title: Locale['Operation'],
            width: 120,
            fixed: "right",
            render: (text: any, record: any) => optype == OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    // txt="添加"
                    txt={Locale['Add']}
                    click={() => add(record)}
                    disabled={
                        !!addDataSource.find(item => item.id === record.id)
                        || record.inventoryNum == 0
                    }
                />
            ) : (
                <YhBut
                    type="delete"
                    // txt="删除"
                    txt={Locale['Delete']}
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType == OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })
    const notHandleSave = (row: IMaterialDetailModel) => {
        let { num, lateSalePrice, inventoryNum, originalNum } = row
        num = +formatIntPoint(num);
        lateSalePrice = +formatIntPoint(lateSalePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        if (num > originalNum) {
            num = originalNum;
            message.warning('修改数量时，不能大于原单的数量');
        }
        let newRow = {
            ...row,
            num,
            amount: (num > inventoryNum ? 0 : num * lateSalePrice)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { num, lateSalePrice, inventoryNum, originalNum } = row
        num = +formatIntPoint(num);
        lateSalePrice = +formatIntPoint(lateSalePrice);
        inventoryNum = +formatIntPoint(inventoryNum);
        if (num > originalNum) {
            num = originalNum;
            message.warning('修改数量时，不能大于原单的数量');
        }
        let newRow = {
            ...row,
            num,
            amount: (num > inventoryNum ? 0 : num * lateSalePrice)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const add = async (record: IMaterialDetailModel) => {
        setAddDataSource(origin => [...origin, record])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }
    const rightChildren = <div className="flex">
        <Button onClick={() => resetMaterialData()} shape="round">{Locale["Reset"]}</Button>
    </div>
    const onOK = async () => {
        transformsToDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setMaterialModel(false);
        setAddDataSource([])
        setSearchWorkData({})
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        // title="选择用料"
        title={Locale["Select Materials"]}
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title={Locale["List of materials to be selected"]} rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.ADD) as ColumnsType<IStockStatisticDetail>}
                dataSource={workDataSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title={Locale["List of selected materials"]}>
            <Table
                rowKey={record => record.id as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectColumns(OPT_TYPE.REMOVE) as ColumnsType<IStockStatisticDetail>}
                dataSource={addDataSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}